module.exports = __webpack_public_path__ + "img/室內裝修專業技術人員登記證.b0ab0cca.png";